module.exports = ({React,connect})->

  class MathTag extends React.Component

    constructor:(props)->
      super(props)
    
    render:->
      active = @props.isSelected && @props.textedit_active_node.type == "duomath"
      <duo-math {...@props.attributes} {...@props.props}></duo-math>
      
  connect((state)->
    toolbars_active:state.toolbars_active
    textedit_active_node:state.textedit_active_node
  )(MathTag)